import { QueryClientProvider } from "react-query";
import React from "react";
import { ReactQueryDevtools } from "react-query/devtools";
import { mediaQueries } from "../../../../libraries/_helpers";
import ReactDataLayer from "../ReactDataLayer/ReactDataLayer";
import { useMedia } from "../../hooks/useMedia";
import { composeForgeVariables } from "../../api/variables";
import MatchHandler from "./MatchHandler";

function ReactApp({ children, queryClient, queryParams }) {
  const { enableQueryTools } = queryParams || {};

  const forgeVariables = composeForgeVariables() || {};

  //MediaQueries
  const { screenMediumLargeMin, screenMediumMin, screenXLargeMin, screenLargeMin } = mediaQueries;

  const mediaQueriesSizes = {
    isXLargeMin: useMedia(screenXLargeMin),
    isMediumLargeMin: useMedia(screenMediumLargeMin),
    isMediumMin: useMedia(screenMediumMin),
    isLargeMin: useMedia(screenLargeMin)
  };

  const hasMatchSportecId = !!window?.forgeVariables?.match?.sportecId;

  return (
    <QueryClientProvider client={queryClient}>
      <ReactDataLayer queryClient={queryClient} mediaQueries={mediaQueriesSizes} queryParams={queryParams} forgeVariables={forgeVariables} >
        {hasMatchSportecId ? (
          <MatchHandler queryClient={queryClient}>
            {children}
          </MatchHandler>
        ) : (
          children
        )}
      </ReactDataLayer>
      {
        enableQueryTools?.[0] === "true"
          ? <ReactQueryDevtools initialIsOpen={false} />
          : null
      }
    </QueryClientProvider>
  );
}

// eslint-disable-next-line no-func-assign
ReactApp = React.memo(ReactApp);

export default ReactApp;
